module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/jszip/~/core-js/library/modules/_fails.js
// module id = 603
// module chunks = 1